import request from "@/utils/request";

// 报销类型树
export function getCategoryTree(param) {
    return request({
        url: '/expensetype/category/tree',
        method: 'get',
        params: param
    })
}

/**
 * 账户
 * @author ConFront_C_Eng
 * @date 2023-11-24 16:12:03
 */
export function getAccountList(param) {
    return request({
        url: '/fm/fmAccount/query',
        method: 'get',
        params: param
    })
}